import { Inject, Injectable } from '@angular/core';
import { CompatClient, Stomp, StompSubscription } from '@stomp/stompjs';
import { Subject } from 'rxjs';
import { APP_ENVIRONMENT } from '@shared/providers/environment.provider';
import { convertPropsToCamelCase } from '@shared/utils/common';
import { Environment } from '../../types/environment';
import { WebSocketTypedResponse } from '../../types/websocket';

@Injectable({
  providedIn: 'root',
})
export class WebsocketService {
  private connection: CompatClient | undefined = undefined;
  private divisionSubscription: StompSubscription | undefined;
  private cargoSubscription: StompSubscription | undefined;
  private invoicesSubscription: StompSubscription | undefined;
  divisionEvents$ = new Subject<WebSocketTypedResponse>();
  cargoEvents$ = new Subject<WebSocketTypedResponse>();
  invoicesEvents$ = new Subject<WebSocketTypedResponse>();
  constructor(@Inject(APP_ENVIRONMENT) private readonly env: Environment) {}

  connect() {
    if (this.connection?.connected) {
      return Promise.resolve(true);
    }
    return new Promise((resolve, reject) => {
      this.connection = Stomp.client(this.env.websocketUrl);
      this.connection.connect(
        {},
        () => {
          return resolve(true);
        },
        () => {
          return reject();
        },
      );
    });
  }

  listenDivision(divisionId: number) {
    const destination = '/division/'.concat(String(divisionId));
    if (this.connection) {
      this.divisionSubscription = this.connection!.subscribe(
        destination,
        message =>
          this.divisionEvents$.next(
            convertPropsToCamelCase(
              JSON.parse(message.body),
            ) as unknown as WebSocketTypedResponse,
          ),
      );
    }
  }

  listenCargo(cargoId: number) {
    const destination = '/cargo/'.concat(String(cargoId));
    if (this.connection) {
      this.cargoSubscription = this.connection!.subscribe(
        destination,
        message =>
          this.cargoEvents$.next(
            convertPropsToCamelCase(
              JSON.parse(message.body),
            ) as unknown as WebSocketTypedResponse,
          ),
      );
    }
  }

  listenInvoices() {
    const destination = '/invoiceProcessing';
    if (this.connection) {
      this.invoicesSubscription = this.connection!.subscribe(
        destination,
        message =>
          this.invoicesEvents$.next(
            convertPropsToCamelCase(
              JSON.parse(message.body),
            ) as unknown as WebSocketTypedResponse,
          ),
      );
    }
  }

  unsubscribeDivision() {
    this.divisionSubscription?.unsubscribe();
  }

  unsubscribeCargo() {
    this.cargoSubscription?.unsubscribe();
  }

  unsubscribeInvoices() {
    this.invoicesSubscription?.unsubscribe();
  }
}
